import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/home.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },
  {
    path: '/mhome',
    name: 'MHome',
    component: () => import('../views/m_home.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import('../views/faq.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },
  {
    path: '/mfaq',
    name: 'MFAQ',
    component: () => import('../views/m_faq.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('../views/terms.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },
  {
    path: '/mterms',
    name: 'Terms',
    component: () => import('../views/m_terms.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('../views/privacy.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },
  {
    path: '/mprivacy',
    name: 'Privacy',
    component: () => import('../views/m_privacy.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },
  {
    path: '/textprivacy',
    name: 'textPrivacy',
    component: () => import('../views/text-privacy.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },
  {
    path: '/mtextprivacy',
    name: 'mtextPrivacy',
    component: () => import('../views/mtext-privacy.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },
  {
    path: '/textterms',
    name: 'textTerms',
    component: () => import('../views/text-terms.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },
  {
    path: '/mtextterms',
    name: 'mtextTerms',
    component: () => import('../views/mtext-terms.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },

  {
    path: '/notice',
    name: 'Notice',
    component: () => import('../views/notice.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },
  {
    path: '/mnotice',
    name: 'MNotice',
    component: () => import('../views/m_notice.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },
  {
    path: '/sub_notice1',
    name: 'sub_notice1',
    component: () => import('../views/sub_notice1.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },
  {
    path: '/sub_notice2',
    name: 'sub_notice2',
    component: () => import('../views/sub_notice2.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },
  {
    path: '/sub_notice3',
    name: 'sub_notice3',
    component: () => import('../views/sub_notice3.vue'),
    meta: {
      title: 'Blue Ridge Bank',
    },
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  to.meta.title && (document.title = to.meta.title)
  document.documentElement.scrollTop = 0
  next()
})

export default router
